import PropTypes from 'prop-types';
import {
  CardHeader,
  Row,
  GgxNumber,
  OrderStatusDesc,
  TrackingCard,
  TitleRow,
  StatusIcon,
} from '@/modules/track-and-trace/track-record-card/track-record-card.styles';
import SearchNotFoundSvg from '@/assets/search-not-found.svg';
import { useTranslation } from 'next-i18next';

const NoRecordCard = ({ trackingId }) => {
  const { t } = useTranslation('common');

  return (
    <TrackingCard>
      <CardHeader canClick={false}>
        <Row>
          <StatusIcon>
            <SearchNotFoundSvg />
          </StatusIcon>
          <div>
            <TitleRow>
              <GgxNumber>{trackingId}</GgxNumber>
            </TitleRow>
            <OrderStatusDesc>{t('tracking_number_not_found_message')}</OrderStatusDesc>
          </div>
        </Row>
      </CardHeader>
    </TrackingCard>
  );
};

NoRecordCard.propTypes = {
  trackingId: PropTypes.string.isRequired,
};

export default NoRecordCard;
